import styled from 'styled-components'
import { Link } from 'react-router-dom'
import media from '../../../../services/generateMediaQueries'

export const FormWrapper = styled.div`
  margin: 1.5rem 0;
  width: 400px;
  ${media.lessThan('medium')`
    width: 100%;
  `}
`
export const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  max-width: 350px;
  font-size: 1.5rem;
  text-align: center;
  margin: auto;
  margin-top: 0;
  color: #3b3636;
  font-weight: var(--font-weight-boldest);
  ${media.lessThan('small')`
    margin-top: revert;
  `}
`
export const StyledLink = styled(Link)`
  text-decoration: none;
  font-weight: var(--font-weight-boldest);
  color: var(--color-primary) !important;
`
export const PerksContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  max-width: 100%;
  align-items: flex-end;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  padding-top: 40px;
  gap: 16px;
  margin: 0 auto;
`
export const Perk = styled.div`
  display: flex;
  flex-direction: column;
  width: 86px;
  justify-content: flex-end;
  align-items: center;
`
export const PerkImage = styled.img`
  // height: ${props => props.height}px;
  width: 86px;
  background-color: #4e6548;
  border-radius: 100px;
  padding: 10px;
`
export const PerkTitle = styled.p`
  color: ${props => props.color};
  text-align: center;
  font-size: var(--size-root);
  font-weight: var(--font-weight-boldest);
  margin: 6px 0;
`
export const PerkDescription = styled.p`
  text-align: center;
  font-size: 10px;
  height: 32px;
  margin: 0;
`
